// @flow
import React, { type Node } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import path from 'ramda/es/path';
import { useTranslation } from 'react-i18next';

import CommonPage from 'app/common/templates/CommonPage';
import * as services from 'app/common/constants/services';
import { getIsAppConnected, getIsAppSubscribed } from 'app/selectors/applications';
import PassagesContainer from 'app/containers/Apps/Passages/PassagesContainer';
import Loading from 'app/components/Loader';
import StudentsSelector from 'app/components/StudentsSelector';
import Nope from 'app/components/common/Nope';
// import StudentsSelector from 'app/components/StudentsSelector';
// import CSSSticky from 'app/common/ui-components/css-sticky';

import RestrictIdentifier from '../RestrictIdentifier';

/**
 *  Страница проходной
 */

type Props = {
  params: {
    id: string,
  },
  children: Node,
}

const PassagesPage = ({ params: { id }, children }: Props) => {
  const { t } = useTranslation('subs');

  const isConnected = useSelector(state => getIsAppConnected(state, { id, app: services.APP_ACCESS }));
  const { loading: loadingStudents, data: students } = useSelector(state => state.students, shallowEqual);
  const { loading: loadingOpts } = useSelector(state => state.apps.opts, shallowEqual);
  const isExternalAvailable = Boolean(path([id, 'passagesExternalService'], students));

  const loading = loadingOpts || loadingStudents;

  const isSubscribed = isConnected || isExternalAvailable;
  const sub = useSelector(state => getIsAppSubscribed(state, { id, app: services.APP_ACCESS }));

  const hasIdentifier = !useSelector(path(['students', 'data', id, 'appsBlocked']), shallowEqual);

  if (loading) {
    return <Loading />;
  }

  return (
    <CommonPage header={t(services.APP_ACCESS)}>
      {/* селектор учеников, когда нет доступа к приложению проходной */}
      {/* приложение содержит собственный селектор TODO вынести сюда */}
      {(!isSubscribed || !hasIdentifier)
        && <StudentsSelector />}

      {!isSubscribed
        && <Nope
          service={services.APP_ACCESS}
          sub={sub}
        />}

      {isSubscribed && !hasIdentifier
        && <RestrictIdentifier studentId={id} />}

      {/* временный PassagesContainer TODO убрать */}
      {isSubscribed && hasIdentifier
        && <PassagesContainer>
          {children}
        </PassagesContainer>}
    </CommonPage>
  );
};

export default PassagesPage;
